import { render, staticRenderFns } from "./TickspeedRow.vue?vue&type=template&id=923ec20c&scoped=true&"
import script from "./TickspeedRow.vue?vue&type=script&lang=js&"
export * from "./TickspeedRow.vue?vue&type=script&lang=js&"
import style0 from "./TickspeedRow.vue?vue&type=style&index=0&id=923ec20c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923ec20c",
  null
  
)

export default component.exports